import { Layout, Form, Input, Button, Row, Col, message } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { firstUpdatePassword } from "../actions/auth";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const FirstUpdatePassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
    const currentUser = useSelector(state => state.auth.user);

    const onFinish = (values) => {
        console.log('Success:', values);
        dispatch(firstUpdatePassword(currentUser ? currentUser.id : null, values.password)).then(() => {
            navigate('/dashboard');
        }).catch((error) => {
            try {
                let responseMessage = error.response.data.message;
                message.error(responseMessage);
            } catch (e) {
                console.log('Failed:', e);
                message.error(JSON.stringify(e));
            }
        });
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        message.error(JSON.stringify(errorInfo));
    };

    useEffect(() => {
        if (!isLoggedIn || !currentUser) {
            navigate('/login');
        } else {
            if (typeof currentUser.needChangePassword !== 'undefined' && currentUser.needChangePassword === false) {
                navigate('/dashboard');
            }
        }
    }, [isLoggedIn, currentUser, navigate]);

    if (!isLoggedIn || !currentUser) {
        return null;
    } else {
        return <Layout className="crm-layout crm-layout--login" style={{ minHeight: '100vh' }}>
            <Form
                name="basic"
                labelCol={{
                    // span: 12,
                }}
                wrapperCol={{
                    span: 6,
                    offset: 9
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Row>
                    <Col span={6} offset={9}>
                        <h1 className="crm-layout__title">{t('firstUpdatePassword.title')}</h1>
                    </Col>
                </Row>

                <Form.Item
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: t('firstUpdatePassword.field.password.required')
                        },
                    ]}
                >
                    <Input.Password placeholder={t('firstUpdatePassword.field.password.placeholder')} />
                </Form.Item>

                <Form.Item
                    name="confirm-password"
                    dependencies={['password']}
                    rules={[
                        {
                            required: true,
                            message: t('firstUpdatePassword.field.repeat-password.required')
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error(t('firstUpdatePassword.field.repeat-password.validator')));
                            },
                        }),
                    ]}
                >
                    <Input.Password placeholder={t('firstUpdatePassword.field.repeat-password.placeholder')} />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        offset: 9,
                        span: 6,
                    }}
                >
                    <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                        {t('firstUpdatePassword.button.update')}
                    </Button>
                </Form.Item>
            </Form>
        </Layout>;
    }
};

export default FirstUpdatePassword;